import App from '@/App'
import { AxiosProvider } from '@/context/axiosContext'
import '@/index.css'
import PersistProvider from '@/redux/providers/persist-provider'
import ThemeProvider from '@/redux/providers/theme-provider'
import { store } from '@/redux/store'
import reportWebVitals from '@/reportWebVitals'
import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { LoadingProvider, useLoading } from '@/context/loadingContext'
import { setupAxiosInterceptors } from '@/utils/axiosInstance'
import { DialogProvider } from '@/context/dialogContext'
import ReactDOM from 'react-dom'

const Root = () => {
  const { startLoading, stopLoading } = useLoading()
  setupAxiosInterceptors(startLoading, stopLoading)

  return <App />
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistProvider>
        <ThemeProvider>
          <LoadingProvider>
            <DialogProvider>
              <AxiosProvider>
                <HelmetProvider>
                  <Root />
                </HelmetProvider>
              </AxiosProvider>
            </DialogProvider>
          </LoadingProvider>
        </ThemeProvider>
      </PersistProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')!,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
